module.exports = __webpack_public_path__ + "static/media/BC2.3831b7ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/BC2.png
// module id = 379
// module chunks = 0